import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import {
  makeStyles,
  createStyles,
  MenuItem,
  TextField,
  Grid,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { getProductReturningReasons } from '../../redux/actions/order'
import { GetMapDispatchTypes } from '@/interfaces/common/redux'

const useStyles = makeStyles((theme) =>
  createStyles({
    formContainer: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      marginLeft: '1.875rem',
      '& .MuiInputLabel-outlined': {
        transform: 'translate(14px, 13px) scale(1)',
      },
      '& .MuiInputLabel-shrink': {
        transform: 'translate(14px, -6px) scale(0.75)',
      },
    },
    formControl: {
      minWidth: 200,
      width: '100%',
    },
    select: {
      '& .MuiOutlinedInput-root': {
        height: 36,
      },
    },
    textField: {
      marginTop: theme.spacing(1),
    },
  })
)

type Tprops = {
  productId: number
  returningRaisonId: number | null
  returningComment: string
  onReturningRaisonChange: (
    productId: number,
    returningRaisonId: number | null
  ) => void
  onReturningCommentChange: (
    productId: number,
    returningComment: string
  ) => void
  returningReasons: any[]
  locale: string
  account: any
  t: any
} & ReturnType<typeof mapStateToProps> &
  GetMapDispatchTypes<typeof mapDispatchToProps>

const ReturningReasonForm = ({
  productId,
  returningRaisonId,
  returningComment,
  onReturningRaisonChange,
  onReturningCommentChange,
  returningReasons,
  getProductReturningReasons,
  locale,
  t,
}: Tprops) => {
  const classes = useStyles()
  const { i18n } = useTranslation()

  useEffect(() => {
    if (!returningReasons || returningReasons.length === 0) {
      getProductReturningReasons(locale || i18n.language)
    }
  }, [])

  const selectedReason = returningReasons?.find(
    (reason) => reason.id === returningRaisonId
  )

  const isOtherReason = selectedReason?.code === 'OTHER'

  return (
    <div className={classes.formContainer}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            value={returningRaisonId || ''}
            onChange={(e) =>
              onReturningRaisonChange(productId, +e.target.value)
            }
            label={t('texts:account:returning_reason_label')}
            variant="outlined"
            select
            fullWidth
            inputProps={{
              displayEmpty: true,
            }}
            classes={{
              root: classes.select,
            }}
          >
            <MenuItem value=""></MenuItem>
            {returningReasons?.map((reason) => (
              <MenuItem key={reason.id} value={reason.id}>
                {reason.translations[0].name}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="returning-reason-comment"
            value={returningComment}
            onChange={(e) =>
              onReturningCommentChange(productId, e.target.value)
            }
            placeholder={t(
              'texts:account:returning_reason_comment_placeholder'
            )}
            label={t('texts:account:returning_reason_comment_label')}
            variant="outlined"
            fullWidth
            required={isOtherReason}
            className={classes.textField}
            multiline
            rows={2}
          />
        </Grid>
      </Grid>
    </div>
  )
}

const mapStateToProps = (state) => ({
  returningReasons: state.returnProducts?.returningReasons,
})

const mapDispatchToProps = {
  getProductReturningReasons: getProductReturningReasons,
}

export default connect(mapStateToProps, mapDispatchToProps)(ReturningReasonForm)
